export default __webpack_public_path__ + "static/media/question.0640482d.svg";